import { useState } from "react";
import { Share24Icon } from "@kaltura/ds-react-icons";
import { ShareProps, ShareModal } from "./ShareModal";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { StyledButton } from "./StyledComponents";
import { MenuItem } from "@kaltura/ds-react-components";
import React from "react";

/**
 * Share Component
 */
export const Share = (props: ShareProps) => {
    const { isHeroAction = false, size = "large", title, playlistId, analyticsData } = props;

    const [openModal, setOpenModal] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const onButtonClick = (openModal: boolean, action: string, buttonType: number) => {
        if (analyticsData) {
            sendButtonAnalytics(analyticsData.action, analyticsData.buttonType, analyticsData.mediaId);
        }
        else {
            const location = isHeroAction ? "Hero" : "Share";
            sendButtonAnalytics(`Media ${location} - ${isHeroAction ? "Share" : action}`, buttonType);
        }
        setOpenModal(openModal);
    };

    const theme = useTheme();
    const isXsScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));
    // when used inside the hero, share button shouldn't have text on xs screens
    const hideButtonText = isHeroAction && isXsScreen;

    return (
        <>
            {playlistId && (
                <MenuItem onClick={() => onButtonClick(true, "Open", ButtonClickAnalyticsType.SHARE)}>
                    {translate("Share")}
                </MenuItem>
            )}
            {!playlistId && (
                <StyledButton
                    id={"kms-ds-share-button"}
                    variant={"borderless"}
                    aria-haspopup={true}
                    aria-expanded={openModal}
                    onClick={() => onButtonClick(true, "Open", ButtonClickAnalyticsType.SHARE)}
                    startIcon={<Share24Icon />}
                    color={"secondary"}
                    isHeroAction={isHeroAction}
                    size={isHeroAction ? size : "medium"}
                    {...(openModal && { "aria-controls": "kms-ds-share-modal" })}
                >
                    {!hideButtonText && (title ?? translate("Share"))}
                </StyledButton>
            )}

            <ShareModal
                modalID={"kms-ds-share-modal"}
                open={openModal}
                onClose={() => {
                    onButtonClick(false, "Close", ButtonClickAnalyticsType.CLOSE);
                }}
                {...props}
            />
        </>
    );
};

export default Share;
